"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExactTimeInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../../constants");
const elements_1 = require("../../../elements");
const TimeInput = styled_1.default.input({
    fontSize: constants_1.theme.font.size[5],
    fontWeight: constants_1.theme.font.weight.bold,
    border: 'none',
    width: 'max-content',
    textAlign: 'center',
    background: 'transparent',
    color: 'inherit',
    '::-webkit-calendar-picker-indicator': {
        display: 'none',
    },
});
const ExactTimeInput = (props) => {
    return ((0, jsx_runtime_1.jsxs)(elements_1.Flex, { gap: 2, items: "center", styles: {
            gridColumn: '2 / 5',
            borderRadius: constants_1.theme.border.radius.small,
            justifyContent: 'center',
            background: constants_1.Color.LIGHTER_GREEN,
            color: constants_1.Color.DARKEST_GREEN,
        }, children: [(0, jsx_runtime_1.jsx)(elements_1.Icon, { name: "CalendarIcon", color: constants_1.Color.DARKEST_GREEN, design: "solid", styles: {
                    mr: 2,
                } }), (0, jsx_runtime_1.jsx)(TimeInput, { type: "time", value: props.startTime, onChange: (e) => props.onStartTimeChange(e.target.value), onBlur: props.onBlur }), (0, jsx_runtime_1.jsx)(elements_1.Text, { children: "-" }), (0, jsx_runtime_1.jsx)(TimeInput, { type: "time", value: props.endTime, onChange: (e) => props.onEndTimeChange(e.target.value), onBlur: props.onBlur })] }));
};
exports.ExactTimeInput = ExactTimeInput;
